import * as AiIcons from "react-icons/ai";
import * as IoIcons from "react-icons/io";
import * as RiIcons from "react-icons/ri";
import CerrarSesion from "./CerrarSesion";
import Cookies from "universal-cookie";
import { DisabledByDefault } from "@mui/icons-material";
import CryptoJS from "crypto-js";

const secretKey = "clave-super-secreta";

export const SidebarDataAdmin = () => {
  const cookies = new Cookies();

  const nombre = cookies.get("Nombre") || "Cargando...";
  const correo = cookies.get("correo") || "";
  const id = cookies.get("id") || "";
  const hash = cookies.get("hash") || "";

  const correoCifrado = correo
    ? CryptoJS.AES.encrypt(correo, secretKey).toString()
    : "";

  const correoCodificado = encodeURIComponent(correoCifrado);

  return [
    {
      title: <span style={{ fontSize: "18px" }}>{nombre}</span>,
      icon: <IoIcons.IoIosPerson />,
    },
    {
      title: "Perfil",
      path: "/PerfilUsuario",
      icon: <IoIcons.IoIosPaper />,
      iconClosed: <RiIcons.RiArrowDownSFill />,
      iconOpened: <RiIcons.RiArrowUpSFill />,
    },
    {
      title: "Información General",
      icon: <AiIcons.AiFillFolderOpen />,
      iconClosed: <RiIcons.RiArrowDownSFill />,
      iconOpened: <RiIcons.RiArrowUpSFill />,
      subNav: [
        {
          title: "Instituciones",
          path: "/CreaInstitucion",
          icon: <AiIcons.AiFillHome />,
        },
        {
          title: "Perfiles",
          path: "/InstitucionPerfilAdmin",
          icon: <AiIcons.AiFillHome />,
        },
        {
          title: "Representante Legal",
          path: "/RepresentanteAdmin",
          icon: <IoIcons.IoIosPerson />,
        },
        {
          title: "Gerente",
          path: "/GerenteAdmin",
          icon: <IoIcons.IoIosPeople />,
        },
        { title: "Sedes", path: "/SedeAdmin", icon: <IoIcons.IoIosMap /> },
        {
          title: "Número Trabajadores",
          path: "/CreaTrabajadores",
          icon: <IoIcons.IoIosPeople />,
        },
        {
          title: "Información Servicios",
          path: `/InfoServicios/${id}`,
          icon: <IoIcons.IoIosSearch />,
        },
        {
          title: "Servicios Lab/Imágenes",
          path: "/InfoServiciosModalidad",
          icon: <IoIcons.IoIosSearch />,
        },
        {
          title: "Capacidad Instalada",
          path: "/CreaCapacidad",
          icon: <IoIcons.IoIosDesktop />,
        },
        {
          title: "Documentación soporte",
          path: "/InfoDocumentacion",
          icon: <IoIcons.IoIosDocument />,
        },
      ],
    },
    {
      title: "Solicitudes",
      path: `/Home/${hash}`,
      icon: <IoIcons.IoIosPaper />,
      iconClosed: <RiIcons.RiArrowDownSFill />,
      iconOpened: <RiIcons.RiArrowUpSFill />,
    },
    {
      title: "Cargues Masivos",
      icon: <AiIcons.AiFillHome />,
      iconClosed: <RiIcons.RiArrowDownSFill />,
      iconOpened: <RiIcons.RiArrowUpSFill />,
      subNav: [
        {
          title: "Indicadores",
          path: "/Indicadores",
          icon: <IoIcons.IoMdList />,
        },
        {
          title: "Om Consecutiva",
          path: "/CargaOmConsecutiva",
          icon: <IoIcons.IoIosBookmark />,
        },
        {
          title: "OM No Agrupadas",
          path: "/OmNoAgrupadas",
          icon: <IoIcons.IoIosRocket />,
        },
        {
          title: "OM Agrupadas",
          path: "/OmAgrupadas",
          icon: <IoIcons.IoIosRocket />,
        },
        {
          title: "OM Solucionadas",
          path: "/OMsolucionada",
          icon: <IoIcons.IoIosRocket />,
        },
      ],
    },
    {
      title: "Asignaciones",
      icon: <AiIcons.AiFillHome />,
      iconClosed: <RiIcons.RiArrowDownSFill />,
      iconOpened: <RiIcons.RiArrowUpSFill />,
      subNav: [
        {
          title: "Asignar Equipo Evaluador",
          path: "/AsignarEquipo",
          icon: <IoIcons.IoMdPeople />,
        },
        {
          title: "Asignar Director",
          path: "/AsignarDirector",
          icon: <IoIcons.IoMdPeople />,
        },
        {
          title: "Asignar Junta",
          path: "/AsignarJunta",
          icon: <IoIcons.IoMdPeople />,
        },
      ],
    },
    {
      title: "Repositorios",
      icon: <AiIcons.AiFillHome />,
      iconClosed: <RiIcons.RiArrowDownSFill />,
      iconOpened: <RiIcons.RiArrowUpSFill />,
      subNav: [
        {
          title: "Repositorio Información",
          path: "/InfoRepositorio",
          icon: <IoIcons.IoMdRecording />,
        },
        {
          title: "Repositorio Fichas",
          path: "/RepositorioFichas",
          icon: <IoIcons.IoMdPeople />,
        },
      ],
    },
    {
      title: "Instrumentos Evaluativos",
      path: "/Encuestas",
      icon: <IoIcons.IoMdPaperPlane />,
    },
    {
      title: "",
      path: "/",
      icon: <CerrarSesion />,
    },
  ];
};
